import { AbilitySubject, every, not, some } from "@cdv/jazz-auth";
import { CurrentUser, Page, User, UserRole } from "../../api";
import { isAdmin, isAppuser } from "../utils";
import { db } from "../../db";

const isMarketing = (user: CurrentUser) => user.role === UserRole.Marketing;

export default function definePageAbility(can: AbilitySubject<User>): void {
  can("read", not(isAppuser));
  can("sync", isAppuser);
  can(["update", "create", "delete"], some(isMarketing, isAdmin));
}
